/**
 * Fiscal Device Factory
 * Yazarkasa Fabrika Fonksiyonu
 * 
 * Seçilen yazarkasa markasına göre doğru entegrasyon sınıfını döndürür.
 */

import { IFiscalDevice, FiscalDeviceType } from './types';
import { huginT300Device } from './hugin';
import { inposM530Device } from './inpos';
import { bekoTokenDevice } from './beko-token';
import { pavopayDevice } from './pavopay';
import { ingenico5000fDevice } from './ingenico';

/**
 * Yazarkasa cihazı fabrika fonksiyonu
 * @param deviceType - Seçilen yazarkasa tipi
 * @returns Yazarkasa entegrasyon instance'ı
 */
export function getFiscalDevice(deviceType: FiscalDeviceType): IFiscalDevice {
  switch (deviceType) {
    case 'hugin_t300':
      return huginT300Device;
    
    case 'inpos_m530':
      return inposM530Device;
    
    case 'beko_x30tr':
    case 'beko_300tr':
      return bekoTokenDevice;
    
    case 'pavopay':
      return pavopayDevice;
    
    case 'ingenico_5000f':
      return ingenico5000fDevice;
    
    default:
      console.warn(`[Fiscal Device Factory] Bilinmeyen cihaz tipi: ${deviceType}, varsayılan olarak Hugin T300 kullanılıyor`);
      return huginT300Device;
  }
}

/**
 * Yazarkasa cihazının desteklenip desteklenmediğini kontrol et
 * @param deviceType - Yazarkasa tipi
 * @returns Cihazın aktif olup olmadığı
 */
export function isFiscalDeviceSupported(deviceType: FiscalDeviceType): boolean {
  switch (deviceType) {
    case 'hugin_t300':
      return true; // ✅ Aktif
    
    case 'inpos_m530':
      return true; // ✅ Aktif
    
    case 'beko_x30tr':
    case 'beko_300tr':
      return true; // ✅ Aktif
    
    case 'pavopay':
      return true; // ✅ Aktif
    
    case 'ingenico_5000f':
      return true; // ✅ Aktif
    
    default:
      return false;
  }
}

/**
 * Yazarkasa cihazının görünen adını al
 * @param deviceType - Yazarkasa tipi
 * @returns Görünen ad
 */
export function getFiscalDeviceDisplayName(deviceType: FiscalDeviceType): string {
  switch (deviceType) {
    case 'hugin_t300':
      return 'Hugin T300';
    
    case 'inpos_m530':
      return 'Inpos M530';
    
    case 'beko_x30tr':
      return 'Beko X30TR';
    
    case 'beko_300tr':
      return 'Beko 300TR';
    
    case 'pavopay':
      return 'PavoPay POS';
    
    case 'ingenico_5000f':
      return 'Ingenico 5000F';
    
    default:
      return 'Bilinmeyen Cihaz';
  }
}

